<template>
  <BaseDialog
    v-model="internalValue"
    @input="$emit('input', $event)"
    :title="computedTitle"
    :subtitle="computedSubtitle"
    :cancelText="'Cancel·la'"
    :confirmText="'Desa'"
    :loading="loading"
    :maxWidth="'600px'"
    :backgroundColor="'#f9efd5'"
    :confirmColor="'#ff0000'"
    role="dialog"
    aria-modal="true"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
  </BaseDialog>
</template>

<script>
import BaseDialog from './BaseDialog.vue'

export default {
  name: 'DeleteRelEntityEventDialog',
  components: { BaseDialog },
  props: {
    value: { type: Boolean, required: true },
    loading: { type: Boolean, default: false },
    title: {
      type: String,
      default: 'Eliminar Equip'
    },
    subtitle: {
      type: String,
      default: 'Estàs segur que vols eliminar el equip?'
    }
  },
  computed: {
    internalValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    computedTitle () {
      return this.title
    },
    computedSubtitle () {
      return this.subtitle
    }
  },
  methods: {
    onCancel () {
      if (this.loading) return
      this.$emit('input', false)
    },
    onConfirm () {
      this.$emit('confirm')
    }
  }
}
</script>
